module.exports = __webpack_public_path__ + "static/media/6.aed90eb2.jpg";